import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './cylindricalparallelism.component.html',
    standalone: false
})
export class CylindricalParallelismPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  cylindricalparallelisms: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.cylindricalparallelisms = this.plugin.config.CylindricalParallelisms;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'cylindricalparallelism',
      'edit'
    ];
  }
}

PluginComponent.plugins['cylindricalparallelism'] = CylindricalParallelismPluginComponent;
